import { requestApi } from '@app/api';
import { withBulkRequest } from '@app/api/paths';

export interface PutBulkRequestSigningDuration {
  signingDuration: number;
}

export function putBulkRequestsSigningDuration(
  workspaceId: string,
  bulkRequestId: string,
  data: PutBulkRequestSigningDuration
) {
  return requestApi<void>({
    url: withBulkRequest(
      `/workspaces/${workspaceId}/bulk-requests/${bulkRequestId}/signing-duration`
    ),
    method: 'PUT',
    credentials: true,
    data,
  }).then((response) => response.data);
}
